export default "__VITE_ASSET__BcBbOK71__"